define('lq/events/actions/distanceMatrix',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function DistanceMatrix(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(DistanceMatrix, EventAction);

    DistanceMatrix.typeName = 'DistanceMatrix';

    DistanceMatrix.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    DistanceMatrix.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "DistanceMatrix",
            command: this.eventData.command
        };
    };

    DistanceMatrix.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    }

    return DistanceMatrix;
});
